var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 py-0 mt-4"},[_c('h1',[_vm._v("You don't have an internet connection")]),_vm._v(" "),_c('h5',[_vm._v("Please check your internet connection.")])])}
var staticRenderFns = []

export { render, staticRenderFns }